import clsx from 'clsx'
import PropTypes from 'prop-types'
import React from 'react'
import { useTranslation } from 'react-i18next'
import { NavLink } from 'react-router-dom'
import BetaLabel from 'components/BetaLabel'
import styles from '../nav.module.scss'

const MarketplaceToolsLink = React.forwardRef(
  ({ className, activeClassName, exact, to, children, ...rest }, ref) => {
    const { t } = useTranslation()

    return (
      <NavLink
        activeClassName={activeClassName}
        className={className}
        exact={exact}
        innerRef={ref}
        to={to}
        {...rest}
      >
        {children}
        <BetaLabel className={styles['nav__link-label']}>
          {t('common::beta')}
        </BetaLabel>
        <BetaLabel
          className={clsx(styles['nav__link-badge'], styles['nav__link-badge_beta'])}
        >
          β
        </BetaLabel>
      </NavLink>
    )
  },
)

MarketplaceToolsLink.displayName = 'MarketplaceToolsLink'

export default MarketplaceToolsLink

MarketplaceToolsLink.propTypes = {
  className: PropTypes.string,
  activeClassName: PropTypes.string,
  exact: PropTypes.bool,
  to: PropTypes.string,
  children: PropTypes.node,
}
